import moment from "moment/moment";
import {EventType} from "features/model/types/EventType";

export const handleShowMore = (events: EventType[], eventsData: any[], setSelectedEvents: any, setIsModalOpen: any) => {
    const start = moment.min(events.map(event => moment(event.start))).toDate();
    const end = moment.max(events.map(event => moment(event.end))).toDate();

    // Фильтрация событий, попадающих в выбранный диапазон
    const eventsInSlot = eventsData.filter(
        (event) =>
            moment(event.start).isBetween(start, end, null, '[]') ||
            moment(event.end).isBetween(start, end, null, '[]') ||
            (moment(event.start).isSameOrBefore(start) && moment(event.end).isSameOrAfter(end))
    );

    // Открываем модальное окно только если есть события
    if (eventsInSlot.length > 0) {
        setSelectedEvents(eventsInSlot);
        setIsModalOpen(true);
    }
};
